module.exports = __webpack_public_path__ + "img/Kibe05.d999ff81.jpg";